<template>
  <v-app :dark="isDark">
    <v-card class="report-screen" :class="{ 'dark-mode': isDark }">
<!--      <v-toolbar dark color="primary">-->
<!--        <v-btn icon @click="goBack">-->
<!--          <v-icon>mdi-arrow-left</v-icon>-->
<!--        </v-btn>-->
<!--        <v-toolbar-title>Отчет о проделанной работе</v-toolbar-title>-->
<!--        <v-spacer></v-spacer>-->
<!--      </v-toolbar>-->

      <div class="report-content">
        <!-- Report text area -->
        <div class="report-text-container">
          <div class="report-text-label">Напишите что вы сделали</div>
          <textarea
            v-model="reportText"
            class="report-textarea"
            placeholder=""
            rows="5"
          ></textarea>
        </div>

        <!-- Image upload section -->
        <div class="image-upload-section">
          <div class="image-upload-label">Добавьте изображение</div>
          <div class="image-upload-buttons">
            <label class="image-upload-btn camera-btn">
              <input type="file" accept="image/*" capture="camera" @change="onImageSelected" class="hidden-input">
              <span class="button-content">
                <v-icon size="24" color="white">mdi-camera</v-icon>
                <span class="btn-text">Камера</span>
              </span>
            </label>
            <label class="image-upload-btn gallery-btn">
              <input type="file" accept="image/*" @change="onImageSelected" class="hidden-input">
              <span class="button-content">
                <v-icon size="24" color="white">mdi-image</v-icon>
                <span class="btn-text">Галерея</span>
              </span>
            </label>
          </div>

          <!-- Preview images -->
          <div class="image-preview-container" v-if="selectedImages.length > 0">
            <div v-for="(image, index) in selectedImages" :key="index" class="image-preview">
              <img :src="image" alt="Preview" />
              <button class="remove-image-btn" @click="removeImage(index)">
                <v-icon small color="white">mdi-close</v-icon>
              </button>
            </div>
          </div>
        </div>
      </div>

      <v-footer :dark="isDark" fixed>
        <v-btn block color="primary" class="white--text" height="56px" @click="submitReport">
          Отправить отчет
        </v-btn>
      </v-footer>
    </v-card>
  </v-app>
</template>

<script>
export default {
  name: 'ReportCreationScreen',
  props: {
    id: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      reportText: '',
      selectedImages: [],
      taskData: null,
      theme: 'light'
    };
  },
  computed: {
    isDark() {
      return this.theme === 'dark';
    },
    isBridgeAvailable() {
      return require('@orta/bridge').isWebViewBridgeAvailable();
    }
  },
  created() {
    console.log('ReportCreationScreen created with id:', this.id);
    console.log('Route params:', this.$route.params);

    // Get theme from route query param or localStorage
    this.theme = this.$route.query.theme || localStorage.getItem('theme') || 'light';

    this.fetchTaskData();
  },
  mounted() {
    if (this.isBridgeAvailable) {
      require('@orta/bridge').setTitle('Отчет о проделаной работе');
      require('@orta/bridge').backArrow.setMode(true);
      require('@orta/bridge').backArrow.setVisible(true);
      require('@orta/bridge').backArrow.setOnClickHandler(this.goBack);
    }
  },
  methods: {
    goBack() {
      // Look at the browser's history first
      if (window.history.length > 2) {
        this.$router.go(-1);
      } else {
        // If no history, go to home with theme preserved
        this.$router.push({ path: '/', query: { theme: this.theme } });
      }
    },
    submitReport() {
      console.log('Submitting report with id:', this.id);

      // Get tasks from localStorage
      const storedTasks = localStorage.getItem('tasks');
      if (storedTasks) {
        const tasks = JSON.parse(storedTasks);

        // Get the task ID from either the taskData object or route params
        const taskId = this.taskData ? this.taskData.id : (this.id || this.$route.params.id);
        console.log('Looking for task with ID:', taskId);

        // Convert both sides to strings for proper comparison
        const taskIndex = tasks.findIndex(t => String(t.id) === String(taskId));
        console.log('Task index:', taskIndex);

        if (taskIndex !== -1) {
          console.log('Found task to update:', tasks[taskIndex]);

          // Mark task as completed
          tasks[taskIndex].completed = true;
          tasks[taskIndex].reportText = this.reportText;
          tasks[taskIndex].reportImages = this.selectedImages;

          // Save updated tasks back to localStorage
          localStorage.setItem('tasks', JSON.stringify(tasks));

          // Also save to custom storage for consistency with HomeView
          try {
            const storage = require('@orta/bridge').storage;
            storage.setItem('tasks', JSON.stringify(tasks));
          } catch (error) {
            console.warn('Could not save to custom storage:', error);
          }

          console.log('Task marked as completed, navigating to success screen');
          // Save theme to localStorage for consistency
          localStorage.setItem('theme', this.theme);

          // Navigate to success screen with theme preserved
          this.$router.push({
            path: '/success',
            query: { theme: this.theme }
          });
        } else {
          console.error('Task not found with ID:', taskId);
          alert('Не удалось найти задачу для отчета. Вернитесь на главный экран.');
        }
      } else {
        console.error('No tasks found in localStorage');
        alert('Не удалось найти данные задач. Вернитесь на главный экран.');
      }
    },
    fetchTaskData() {
      // Get tasks from localStorage
      const storedTasks = localStorage.getItem('tasks');
      console.log('ReportCreation - Stored tasks:', storedTasks);

      if (storedTasks) {
        const tasks = JSON.parse(storedTasks);
        // Convert both to string for comparison since route params are always strings
        const taskId = this.id || this.$route.params.id;
        console.log('ReportCreation - Looking for task with id:', taskId);

        this.taskData = tasks.find(task => String(task.id) === String(taskId));
        console.log('ReportCreation - Found task:', this.taskData);

        if (this.taskData) {
          // Initialize report text with task title
          // this.reportText = `Задача: ${this.taskData.title}\n\n${this.taskData.description || ''}`;
          this.reportText = '';
        } else {
          console.warn('ReportCreation - Task not found with id:', taskId);
          // If task not found, go back to home
          this.$router.push('/');
        }
      } else {
        console.warn('ReportCreation - No stored tasks found');
        // No tasks found, go back to home
        this.$router.push('/');
      }
    },
    onImageSelected(event) {
      const file = event.target.files[0];
      if (file) {
        try {
          // Create a preview of the selected image
          const reader = new FileReader();
          reader.onload = (e) => {
            // Add the image to the list of selected images
            this.selectedImages.push(e.target.result);

            // Clear the input to allow selecting the same file again
            event.target.value = '';
          };
          reader.readAsDataURL(file);
        } catch (error) {
          console.error('Error processing image:', error);
          // If there's an error with the file API (possibly due to WebView restrictions),
          // fall back to demo images
          const demoImages = [
            'https://images.unsplash.com/photo-1575936123452-b67c3203c357?q=80&w=500',
            'https://images.unsplash.com/photo-1517598024396-46c53fb391a1?q=80&w=500'
          ];
          const randomImage = demoImages[Math.floor(Math.random() * demoImages.length)];
          this.selectedImages.push(randomImage);
        }
      }
    },
    removeImage(index) {
      // Remove the image at the specified index
      this.selectedImages.splice(index, 1);
    }
  }
}
</script>

<style scoped>
.report-screen {
  flex: 1;
  background-color: var(--bg-color) !important;
  border-radius: 0 !important;
}

.report-content {
  padding: 16px;
  margin-bottom: 56px; /* Space for footer */
}

.report-text-container {
  margin-bottom: 24px;
  background-color: var(--bg-color-secondary);
  border-radius: 8px;
  padding: 12px 16px;
}

.report-text-label {
  font-size: 14px;
  color: #757575;
  margin-bottom: 8px;
}

.report-textarea {
  width: 100%;
  border: none;
  background-color: transparent;
  color: var(--text-color);
  font-size: 16px;
  resize: none;
  outline: none;
  font-family: 'Inter', sans-serif;
}

.image-upload-section {
  margin-bottom: 24px;
}

.image-upload-label {
  font-size: 16px;
  font-weight: 500;
  color: var(--text-color);
  margin-bottom: 16px;
}

.image-upload-buttons {
  display: flex;
  gap: 16px;
  margin-bottom: 16px;
}

.image-upload-btn {
  width: 100px;
  height: 44px;
  border-radius: 22px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  padding: 0 16px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.camera-btn {
  background-color: #4285F4;
}

.gallery-btn {
  background-color: #34A853;
}

.button-content {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}

.btn-text {
  color: white;
  font-weight: 500;
  font-size: 14px;
}

.hidden-input {
  position: absolute;
  width: 0;
  height: 0;
  opacity: 0;
  overflow: hidden;
}

.image-preview-container {
  margin-top: 16px;
}

.image-preview {
  position: relative;
  border-radius: 8px;
  overflow: hidden;
  margin-bottom: 16px;
}

.image-preview img {
  width: 100%;
  display: block;
}

.remove-image-btn {
  position: absolute;
  top: 8px;
  right: 8px;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  cursor: pointer;
}
</style>
